import { getPlanName } from './plans'

export const getLicensePlan = (licenses) =>
  getPlanName(licenses.plan).toLowerCase().split('_').join(' ')
